import React from 'react';

import {
  FormControl,
  RadioGroup,
  RadioGroupProps,
} from '@mui/material';

import { COLOR_BORDER } from '~/components/App/theme';
import { IConfigurationOption } from '~/domain/IConfigurationOption';

import { ConfigurationPackColors } from './ConfigurationPackColors';

interface IConfigurationRadio {
  label: React.ReactNode;
  packs: IConfigurationOption[];
  onChange: RadioGroupProps['onChange'];
  value?: string;
}

export const ConfigurationPackSetColors = React.memo<IConfigurationRadio>(
  function ConfigurationRadio(props) {
    const { packs, onChange, value } = props;
    
    return (
      <FormControl
        sx={{
          width: '100%',
          borderBottom: `1px solid ${COLOR_BORDER}`,
          '&:last-of-type': { borderBottom: 0 },
        }}
      >

        <RadioGroup value={value} onChange={onChange}>
          {packs.map((pack,index) => {
            return (
              <ConfigurationPackColors pack={pack} key={Date.now()*index} />
            );
          })}
        </RadioGroup>

      </FormControl>
    );
  }
);
